import { Filter, FunnelX } from '@myosh/icons';
import { Button } from '@myosh/odin-components';
import { useTranslation } from 'react-i18next';

interface FilterActionsProps {
  canApply: boolean;
  onReset: () => void;
  onApply: () => void;
}

export const FilterActions = ({ canApply, onReset, onApply }: FilterActionsProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-2">
      <Button variant="outline" className="flex-1" onClick={onReset}>
        <FunnelX data-icon="inline-start" />
        {t(($) => $.reset)}
      </Button>
      <Button className="flex-1" disabled={!canApply} onClick={onApply}>
        <Filter data-icon="inline-start" />
        {t(($) => $.applyFilters)}
      </Button>
    </div>
  );
};
